import { render, staticRenderFns } from "./TkCitySub.vue?vue&type=template&id=5c68585d&scoped=true&"
import script from "./TkCitySub.vue?vue&type=script&lang=js&"
export * from "./TkCitySub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68585d",
  null
  
)

export default component.exports